module.exports = __webpack_public_path__ + "img/responsive hospitium-10.3b366881.jpg";